export enum TradeType {
  EXACT_INPUT = 0,
  EXACT_OUTPUT = 1,
}

export enum Bound {
  LOWER = "LOWER",
  UPPER = "UPPER",
}
